
<f-dialog
    v-if         = "contact"
    v-model      = "value"
    :width       = "1300"
    :show-delete = "false"
    :show-header = "false"
    @cancel      = "onCancel"
    @store       = "onSave"
>
    <template v-slot:content>
        <v-form ref="form">
            <v-row class="no-frame mt-3 pl-1">
                <v-col class="no-frame pr-1 col-4" style="display: flex; flex-direction: column">
                    <v-row class="no-frame" >
                        <v-col class="no-frame col-12">
                            <c-column-header class="primary mb-1" label="Kontakt" />
                            <div class="  lm-border pa-3" style="height: 426px;">
                                <v-row class="no-frame">
                                    <v-col class="no-frame pr-2 col-4">
                                        <f-enum-select
                                            v-model      = "contact.salutation"
                                            label        = "Anrede"
                                            module       = "msd"
                                            type         = "salutation"
                                        />
                                    </v-col>
                                    <v-col class="no-frame pl-2">
                                        <f-enum-select
                                            v-model      = "contact.status"
                                            label        = "Status"
                                            module       = "msd"
                                            type         = "contactStatus"
                                        />
                                    </v-col>
                                </v-row>

                                <v-row class="no-frame" v-if="!isPerson">
                                    <v-col class="no-frame">
                                        <v-text-field
                                            label          = "Name"
                                            v-model        = "contact.name"
                                            :rules         = "[requiredRule]"
                                            autocomplete   = "off"
                                            autocorrect    = "off"
                                            autocapitalize = "off"
                                            spellcheck     = "false"
                                        />
                                    </v-col>
                                </v-row>

                                <v-row class="no-frame" v-if="isPerson">
                                    <v-col class="no-frame pr-2 col-4">
                                        <v-text-field
                                            label          = "Vorname"
                                            v-model        = "contact.firstname"
                                            autocomplete   = "off"
                                            autocorrect    = "off"
                                            autocapitalize = "off"
                                            spellcheck     = "false"
                                        />
                                    </v-col>
                                    <v-col class="no-frame pl-2">
                                        <v-text-field
                                            label          = "Name"
                                            v-model        = "contact.name"
                                            :rules         = "[requiredRule]"
                                            autocomplete   = "off"
                                            autocorrect    = "off"
                                            autocapitalize = "off"
                                            spellcheck     = "false"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row class="no-frame" v-if="mode === 'customer'">
                                    <v-radio-group
                                        v-model   = "customerContactType"
                                        class     = "ma-0 mt-1 mb-2"
                                        hide-details
                                        dense
                                    >
                                        <v-radio
                                            :ripple = "false"
                                            class   = "mt-0 pt-0 ma-0 w-100"
                                            @click  = "onContactType"
                                            value   = "customer"
                                            color   = "primary"
                                            hide-details
                                        >
                                            <template v-slot:label>
                                                <span class="primary white--text pa-1 pl-2 pr-2 w-100" style="border-radius: 4px;">Ansprechpartner beim Kunden</span>
                                            </template>
                                        </v-radio>

                                        <v-radio
                                            :ripple = "false"
                                            class   = "mt-2 pt-0 ma-0 w-100"
                                            @click  = "onContactType"
                                            color   = "primary"
                                            value   = "onsite"
                                            hide-details
                                        >
                                            <template v-slot:label>
                                                <span class="primary white--text pa-1 pl-2 pr-2 w-100" style="border-radius: 4px;">Ansprechpartner vor Ort</span>
                                            </template>
                                        </v-radio>
                                    </v-radio-group>
                                </v-row>

                                <v-row class="no-frame" v-if="!isOnsite">
                                    <v-col class="no-frame">
                                        <v-select
                                            :items     = "roles"
                                            item-value = "id"
                                            item-text  = "name"
                                            label      = "Rolle"
                                            return-object
                                            :rules         = "[requiredRule]"
                                            v-model    = "contact.roles"
                                            multiple
                                        >
                                            <template v-slot:selection="{ item, index }">
                                                <div class="v-flex">
                                                    <div v-if="index === 0">{{ item.name }}</div>
                                                    <div
                                                        v-if="index === 1"
                                                        class="grey--text text-caption ml-1"
                                                    >
                                                        {{ '(+' + (contact.roles.length - 1) + ' weitere)'}}
                                                    </div>
                                                </div>
                                            </template>
                                        </v-select>
                                    </v-col>
                                </v-row>

                                <v-row class="no-frame">
                                    <v-col class="no-frame">
                                        <v-textarea
                                            class          = "pt-0"
                                            v-model        = "contact.comment"
                                            rows           = "4"
                                            autocomplete   = "off"
                                            autocorrect    = "off"
                                            autocapitalize = "off"
                                            spellcheck     = "false"
                                            no-resize
                                            hide-details
                                        />
                                    </v-col>
                                </v-row>
                            </div>
                        </v-col>
                    </v-row>
                    <div class="no-frame mt-2">
                        <c-column-header class="primary mb-1" label="Zuständig für ..." >
                            <template v-slot:filter>
                                <div class="pr-6">
                                    <v-icon size="20" color="white">mdi-card-account-mail</v-icon>
                                    <v-icon size="20" class="pl-3" color="white">mdi-card-account-mail-outline</v-icon>
                                </div>
                            </template>
                        </c-column-header>

                        <div class="lm-border pa-3 pt-0" :key="refreshResponsibilities" >
                            <div class="mr-0 pt-2" style="display: flex; flex-wrap: wrap; flex-direction: column; margin-top: -3px">
                                <contact-responsiblity
                                    v-for    = "(item, index) in resonsibilities" :key="index"
                                    :item    = "item"
                                    style    = "flex-grow: 1; width: 100%"
                                    @changed = "onChanged"
                                />
                            </div>
                            <v-divider class="mt-5 mb-5" />
                            <div>
                                <v-select
                                    v-if           = "incidentTypes"
                                    :items         = "incidentTypes"
                                    item-value     = "id"
                                    item-text      = "name"
                                    label         = "Bei Ereignis"
                                    v-model        = "contact.incidenttypes"
                                    :return-object = true
                                    :multiple      = "true"
                                    :clearable     = "false"
                                    class="mb-2"
                                    hide-details
                                    chips
                                >
                                    <template v-slot:selection="data">
                                        <v-chip
                                            v-if="data.index < 3"
                                            @click:close = "onRemoveIncidentType(data.item)"
                                            color=       "primary"
                                            style="margin: 1px"
                                            small
                                            close
                                            close-icon="mdi-close"
                                        >
                                            <div class="pl-1">
                                                <div class="selected-incidenttype">
                                                    {{ data.item.name }}
                                                </div>
                                            </div>
                                        </v-chip>
                                        <span
                                            v-if="data.index === maxIncidentTypes && contact.incidenttypes.length > maxIncidentTypes"
                                            class="selected-incidenttype-others"
                                        >
                                            (+ {{ contact.incidenttypes.length - maxIncidentTypes }} weitere)
                                        </span>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </div>
                </v-col>
                <v-col class="no-frame pl-1 col-4">
                    <v-row class="no-frame">
                        <v-col class="no-frame col-12">
                            <c-column-header class="primary mb-1" label="Anlagenzuordnung" />
                            <div class="lm-border pa-3" style="height: 170px">
                                <v-row class="no-frame">
                                    <v-col class="no-frame">
                                        <f-enum-select
                                            v-model      = "contact.siteAssignmentType"
                                            label        = "Anlagenzuordnung"
                                            module       = "msd"
                                            type         = "contactSiteAssignmentType"
                                            :readonly    = "isOnsite"
                                            :exclude     = "isCustomer ? [ 3 ] : []"
                                        />

                                    </v-col>
                                </v-row>
                                <v-row class="no-frame" v-if="contact.siteAssignmentType && contact.siteAssignmentType.id === 3">
                                    <v-col class="no-frame">
                                        <c-customer-select
                                            v-model     = "contact.customer"
                                            label      = "Kunde"
                                            :lim-customer = "true"
                                            :rules      = "[requiredRule]"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row class="no-frame" v-if="!contact.siteAssignmentType || contact.siteAssignmentType.id !== 3">
                                    <v-col class="no-frame">
                                        <v-text-field
                                            label          = "Kennzeichen"
                                            v-model        = "contact.tags"
                                            autocomplete   = "off"
                                            autocorrect    = "off"
                                            autocapitalize = "off"
                                            spellcheck     = "false"
                                        />
                                    </v-col>
                                </v-row>
                            </div>

                            <c-column-header class="primary mb-1 mt-2" label="Email, Telefon" />


                            <f-phone-numbers
                                v-model = "contact.phonenumbers" style="height: 555px"
                            >
                                <template v-slot:pre>
                                    <v-text-field
                                        label="Email"
                                        v-model        = "contact.email"
                                        :rules         = "[requiredNotHotlineRule]"
                                        autocomplete   = "off"
                                        autocorrect    = "off"
                                        autocapitalize = "off"
                                        spellcheck     = "false"
                                        class          = "mt-3 mb-4"
                                    />
                                </template>
                            </f-phone-numbers>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col class="no-frame pl-2 col-4">
                    <!-- Service Contact -->
                    <v-row
                        class = "no-frame"
                    >
                        <v-col class="no-frame col-12">
                            <c-column-header
                                label = "Unternehmen"
                                class = "primary"
                            />
                            <div class="lm-border pa-3 mt-1" style="height: calc(100% - 34px)">
                                <v-row class="no-frame" v-if="isCustomer && !isOnsite">
                                    <v-col class="no-frame">
                                        <v-switch
                                            v-model = "customerContact"
                                            label   = "direkt beim Kunden"
                                            class   = "mt-2 mb-3"
                                            dense
                                            hide-details
                                        />
                                    </v-col>
                                </v-row>
                                <v-row class="no-frame"  v-if="!isOnsite">
                                    <v-col class="no-frame">
                                        <v-autocomplete
                                            v-if           = "companies"
                                            :items         = "companies"
                                            item-value     = "id"
                                            item-text      = "name"
                                            label          = "Auswahl"
                                            v-model        = "contact.company"
                                            :return-object = true
                                            @change        = "onCompany"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row
                                    v-if  = "!isUnknowCompany"
                                    class = "no-frame col-12"
                                >
                                    <div class="primary--text">Adresse</div>
                                    <company-card
                                        v-if     = "contact && contact.company"
                                        :company = "contact.company"
                                        class    = "mt-1 w-100"
                                    />
                                </v-row>
                                <c-v-spacer />
                            </div>
                        </v-col>
                    </v-row>
                    <!-- Service Contact -->

                    <div class="lm-border mt-2 pa-3" style="height: calc(100% - 254px)" v-if="!isAdmin">
                    </div>

                    <c-column-header
                        label = "Informationen"
                        class = "primary mt-2"
                    />
                    <div class="lm-border mt-1 pa-3" style="height: calc(100% - 288px)" v-if="isAdmin">
                        <v-row class="no-frame " >
                            <v-col class="no-frame">
                                Erstellt von / am
                            </v-col>
                            <v-col class="no-frame">
                                {{ contact.createdBy }}
                            </v-col>
                        </v-row>
                        <v-row class="no-frame " >
                            <v-col class="no-frame">
                                Erstellt am
                            </v-col>
                            <v-col class="no-frame">
                                {{ formatDateTime (contact.createdDate) }}
                            </v-col>
                        </v-row>
                        <v-row class="no-frame mt-4" >
                            <v-col class="no-frame">
                                Zuletzt bearbeitet von
                            </v-col>
                            <v-col class="no-frame">
                                {{ contact.modifiedBy }}
                            </v-col>
                        </v-row>
                        <v-row class="no-frame" >
                            <v-col class="no-frame">
                                Zuletzt bearbeitet am
                            </v-col>
                            <v-col class="no-frame">
                                {{ formatDateTime (contact.modifiedDate) }}
                            </v-col>
                        </v-row>
                    </div>
                </v-col>
            </v-row>
        </v-form>
    </template>
</f-dialog>
